import * as React from 'react'

function SvgRideableByTruck(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={31} height={31} viewBox="0 0 17 17" {...props}>
			<path
				fill="currentColor"
				d="M10.528 9.439h.283v1.998h-.283zm.077 3.894H9.503l-.1-.173h1.202zm-.671-3.894h.284v1.998h-.284zm-.31 1.998H9.34V9.439h.284zm-.593 0h-.285V9.439h.285zm-.593 0h-.284V9.439h.284zm-.76 1.896H6.6v-.173h1.179zm-3.247-2.86a.867.867 0 111.734-.002.867.867 0 01-1.734.002zm3.13-1.034h.286v1.998h-.285zm-.591 0h.285v1.998H6.97zm-.31 1.998h-.283V9.439h.284zm5.857-2.907a.243.243 0 01-.244.243H4.91a.243.243 0 01-.244-.243l.243-2.365c0-.134.11-.245.245-.245h6.875c.134 0 .246.11.246.245zm.233 1.943c0 .48-.386.867-.867.867a.865.865 0 01-.867-.867.866.866 0 111.734 0zm.485-8.221a.243.243 0 00-.244-.243h-8.8a.243.243 0 00-.244.243v10.664c0 .133.109.244.245.244h.163v2.066c0 .135.109.245.244.245h.636a.244.244 0 00.242-.227c.01.125.115.227.243.227h.636c.134 0 .244-.11.244-.245v-1.317h1.156l.314.548h1.04l.317-.548h1.178v1.317c0 .135.109.245.244.245h.637a.245.245 0 00.243-.227.244.244 0 00.242.227h.637c.135 0 .242-.11.242-.245V13.16h.14a.245.245 0 00.245-.244z"
			/>
		</svg>
	)
}

export default SvgRideableByTruck
